import { render, staticRenderFns } from "./PixelSpinner.vue?vue&type=template&id=03e54454&scoped=true&"
import script from "./PixelSpinner.vue?vue&type=script&lang=js&"
export * from "./PixelSpinner.vue?vue&type=script&lang=js&"
import style0 from "./PixelSpinner.vue?vue&type=style&index=0&id=03e54454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e54454",
  null
  
)

export default component.exports